import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {LoginComponent} from './views/login/index';
import {InterviewLoginComponent} from './views/interviewlogin/index';

import {AdminComponent} from './containers/admin/admin.component';
import {ErrorComponent} from './error.component';
import {PasswordComponent} from './views/password/password.component';
// Import Containers
import {
    FullLayoutComponent,
    FullLayoutPublicComponent,
    SimpleLayoutComponent
} from './containers';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
    },
    {
        path: 'admin',
        redirectTo: 'admin/login',
        pathMatch: 'full',
    },
    //{path: 'login', component: LoginComponent},
    {path: 'login', component: InterviewLoginComponent},
    {path: 'password/:token', component: PasswordComponent},
    {
        path: 'admin',

        data: {
            title: 'Home'
        },

        children: [
            {
                path: 'login', 
                component: LoginComponent
            },
            {

                path: 'login',
                component: LoginComponent,

            },
            {
                path: 'dashboard',
                component: FullLayoutComponent,
                loadChildren: './views/dashboard/dashboard.module#DashboardModule'
            },
            {
                path: 'projects',
                component: FullLayoutComponent,
                loadChildren: './views/projects/projects.module#ProjectsModule'
            },
            {
                path: 'sections',
                component: FullLayoutComponent,
                loadChildren: './views/sections/sections.module#SectionsModule'
            },
            {
                path: 'responses',
                component: FullLayoutComponent,
                loadChildren: './views/response/response.module#ResponseModule'
            },
            {
                path: 'users',
                component: FullLayoutComponent,
                loadChildren: './views/users/users.module#UsersModule'
            },
            {
                path: 'branches',
                component: FullLayoutComponent,
                loadChildren: './views/branches/branch.module#BranchModule'
            },
            {
                path: 'profile',
                component: FullLayoutComponent,
                loadChildren: './views/profile/profile.module#ProfileModule'
            },
            {
                path: 'issuecodes',
                component: FullLayoutComponent,
                loadChildren: './views/issuecodes/issuecodes.module#IssuecodesModule'
            },
            {
                path: 'organizations',
                component: FullLayoutComponent,
                loadChildren: './views/organizations/organizations.module#OrganizationsModule'
            },
            {
                path: 'resources',
                component: FullLayoutComponent,
                loadChildren: './views/resources/resources.module#ResourcesModule'
            },
            /*{
                path: 'survey',
                component: FullLayoutComponent,
                loadChildren: './views/survey/survey.module#SurveyModule'
            },*/
            /*{
                path: 'error',
                component: ErrorComponent,
                data: {
                    title: 'Error'
                }
            },
            { 
                path: '**', 
                component: ErrorComponent, 
            }*/
            
        ]
    },
    {
        path: 'pages',
        component: SimpleLayoutComponent,
        data: {
            title: 'Pages'
        },
        children: [
            {
                path: '',
                loadChildren: './views/pages/pages.module#PagesModule',
            }
        ]
    },
    {
        path: 'survey',
        component: FullLayoutPublicComponent,
        loadChildren: './views/survey/survey.module#SurveyModule'
    },
    {
        path: 'profile',
        component: FullLayoutPublicComponent,
        loadChildren: './views/profilepublic/profilePublic.module#ProfilePublicModule'
    },
    {
        path: 'error',
        component: ErrorComponent,
        data: {
            title: 'Error'
        }
    },
    { 
        path: '**', 
        component: ErrorComponent, 
    },
    

];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /var/www/html/LASO/laso-client/src/app/app.routing.ts